import { useContext, useState } from 'react';
import {
  Button,
  Box,
  Text,
  Stack,
  Spinner,
  Center,
  useToast,
  HStack,
} from '@chakra-ui/react';
import CustomToast from '../../../common/CustomToast';
import { CustomCsvDownloadIcon } from '../../../theme/icons/CustomCsvDownloadIcon';
import { HttpContext } from '../../../context/HttpContext';
import { MeContext } from '../../../context/MeContext';
import { useReportAndToastApiError } from '../../../hooks/useReportAndToastApiError';

const MessageBatchResultDownload = (props) => {
  const batchId = props.batchId;
  const { authAxios } = useContext(HttpContext);
  const [isDownloading, setIsDownloading] = useState(false);
  const meCtx = useContext(MeContext);
  const toast = useToast();
  const reportAndToastApiError = useReportAndToastApiError();
  const encodedEmail = encodeURIComponent(meCtx.state.account.email);
  const generateMessageBatchResultData = async () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    await authAxios.get(
      `api/v1/batches/${batchId}?export=true&timezone=${encodeURIComponent(
        userTimezone
      )}&email=${encodedEmail}`
    );

    try {
      toast({
        render: (props) => (
          <CustomToast
            status="info"
            title="Please check your email"
            description={`A download link has been sent to ${meCtx.state.account.email}. It may take a few minutes to arrive.`}
            onClose={props.onClose}
          />
        ),
      });
    } catch (error) {
      setIsDownloading(false);
      reportAndToastApiError(error);
    }
  };

  return (
    <Stack
      spacing="18px"
      direction={{ base: 'column', sm: 'row' }}
      shouldWrapChildren="true"
      position="relative"
    >
      <Button
        size="sm"
        width={{ base: 'full', sm: '198px' }}
        onClick={() => {
          generateMessageBatchResultData();
        }}
        isLoading={isDownloading}
      >
        {isDownloading ? (
          <Center as="span" zIndex={1}>
            <Spinner
              width="15px"
              height="15px"
              thickness="2px"
              speed="0.65s"
              emptyColor="quinaryBackground"
              mx="auto"
            />
          </Center>
        ) : (
          <Box as="span" zIndex={1}>
            <HStack alignItems="center" justifyContent="center">
              <CustomCsvDownloadIcon boxSize="20px" />
              <Text>Email CSV Report</Text>
            </HStack>
          </Box>
        )}
      </Button>
    </Stack>
  );
};

export default MessageBatchResultDownload;
